import React from 'react';
import { ContentCard } from '../ContentCard';

interface ChangelogCardProps {
  title: string;
  excerpt: string;
  slug: string;
}

export function ChangelogCard({ title, excerpt, slug }: ChangelogCardProps) {
  return (
    <ContentCard
      href={`/changelog/${slug}`}
      title={title}
      excerpt={excerpt}
    />
  );
}
